import { noop } from 'rxjs';
import { DEFAULT_TEXT_UNDER_CURSOR, TextUnderCursor } from '../../helpers/textUnderCursor';
import { NULL_SERVICE, Service } from '../base/service';

export interface TextUnderCursorRange {
  startOffset: number;
  endOffset: number;
}

export interface TextUnderCursorService extends Service {
  readonly isActive: boolean;
  readonly textUnderCursor: Readonly<TextUnderCursor>;

  getBoundingClientRect(textRange?: TextUnderCursorRange): ClientRect | undefined;

  setTextUnderCursor(textUnderCursor: Readonly<TextUnderCursor>): void;
}

export const NULL_TEXT_UNDER_CURSOR_SERVICE: TextUnderCursorService = {
  ...NULL_SERVICE,
  isActive: false,
  textUnderCursor: DEFAULT_TEXT_UNDER_CURSOR,
  getBoundingClientRect: () => undefined,
  setTextUnderCursor: noop,
};
